import React, { useState, useEffect } from 'react'

import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper'


import './About.scss';
import { readClient } from '../../client';
import { getSanityImageProps } from '../../utils/sanityImage';



const About = () => {

  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    readClient.fetch(query)
    .then((data) => setAbouts(data))
  
   
  }, [])
  
  return (
    <>
      <h2 className="head-text">I know that <span>good development</span><br/> means <span>good business</span></h2>

      <div className="app__profiles">
      {abouts.map((about, index) =>(
        <motion.div
          whileInView={{ opacity: 1}}
          className="app__profile-item"
          whileHover={{ scale:1.1 }}
          transition={{ duration: 0.5, type: 'tween'}}
          key={about.title + index}
        >
          <img
            {...getSanityImageProps(about.imgUrl, {
              candidates: [
                { width: 190, height: 170 },
                { width: 380, height: 340 },
                { width: 740, height: 640 },
              ],
              sizes: '(min-width: 2000px) 370px, 190px',
            })}
            loading="lazy"
            decoding="async"
            alt={about.title}
          />
          <h2 className="bold-text" style={{ marginTop: 20}}>{about.title}</h2>
          <p className="p-text" style={{ marginTop: 10}}>{about.description}</p>
           
        </motion.div>
      ))}
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  "app__whitebg"
  );
